import { QrCode, Download } from 'lucide-react';
import { Button } from '@/components/ui/button';

const AppDownload = () => {
  return (
    <section id="app-download" data-testid="app-download-section" className="section relative bg-[var(--bg-secondary)] dark:bg-[#1A1A1A] overflow-hidden">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://images.pexels.com/photos/6828169/pexels-photo-6828169.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
          alt="App Download Background"
          className="w-full h-full object-cover opacity-20"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#111111]/90 via-[#111111]/70 to-transparent dark:from-[#111111]/95 dark:via-[#111111]/80"></div>
      </div>

      <div className="container relative z-10">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-12">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-[var(--text-primary)] mb-4" data-testid="app-download-heading">
            It's even better in the app
          </h2>
          <p className="text-base text-[var(--text-secondary)] leading-relaxed">
            Track your barber in real-time, just like Uber. Download the app for the best experience.
          </p>
        </div>

        {/* App Cards */}
        <div className="grid md:grid-cols-2 gap-8 max-w-5xl mx-auto">
          {/* Customer App */}
          <div data-testid="customer-app-card" className="bg-[var(--bg-secondary)] dark:bg-[#1A1A1A] border border-[var(--border-color)] rounded-xl p-8">
            <div className="text-center">
              <div className="inline-flex items-center justify-center w-16 h-16 rounded-2xl bg-[#00C167]/10 text-[#00C167] mb-4">
                <Download className="w-8 h-8" />
              </div>
              <h3 className="text-2xl font-bold text-[var(--text-primary)] mb-2">Customer App</h3>
              <p className="text-[var(--text-secondary)] mb-6">Book barbers on the go</p>

              {/* QR Code Placeholder */}
              <div className="flex justify-center mb-6">
                <div className="w-32 h-32 bg-white rounded-lg flex items-center justify-center border-4 border-[#00C167]">
                  <QrCode className="w-20 h-20 text-[#00C167]" />
                </div>
              </div>

              {/* Download Buttons */}
              <div className="flex flex-col gap-3">
                <Button
                  data-testid="download-ios-customer"
                  variant="outline"
                  className="w-full border-[var(--border-color)] hover:border-[#00C167]"
                >
                  <img src="https://upload.wikimedia.org/wikipedia/commons/6/67/App_Store_%28iOS%29.svg" alt="App Store" className="h-6" />
                </Button>
                <Button
                  data-testid="download-android-customer"
                  variant="outline"
                  className="w-full border-[var(--border-color)] hover:border-[#00C167]"
                >
                  <img src="https://upload.wikimedia.org/wikipedia/commons/7/78/Google_Play_Store_badge_EN.svg" alt="Google Play" className="h-6" />
                </Button>
              </div>
            </div>
          </div>

          {/* Barber App */}
          <div data-testid="barber-app-card" className="bg-[var(--bg-secondary)] dark:bg-[#1A1A1A] border border-[var(--border-color)] rounded-xl p-8">
            <div className="text-center">
              <div className="inline-flex items-center justify-center w-16 h-16 rounded-2xl bg-[#E30613]/10 text-[#E30613] mb-4">
                <Download className="w-8 h-8" />
              </div>
              <h3 className="text-2xl font-bold text-[var(--text-primary)] mb-2">Barber App</h3>
              <p className="text-[var(--text-secondary)] mb-6">Start earning today</p>

              {/* QR Code Placeholder */}
              <div className="flex justify-center mb-6">
                <div className="w-32 h-32 bg-white rounded-lg flex items-center justify-center border-4 border-[#E30613]">
                  <QrCode className="w-20 h-20 text-[#E30613]" />
                </div>
              </div>

              {/* Download Buttons */}
              <div className="flex flex-col gap-3">
                <Button
                  data-testid="download-ios-barber"
                  variant="outline"
                  className="w-full border-[var(--border-color)] hover:border-[#E30613]"
                >
                  <img src="https://upload.wikimedia.org/wikipedia/commons/6/67/App_Store_%28iOS%29.svg" alt="App Store" className="h-6" />
                </Button>
                <Button
                  data-testid="download-android-barber"
                  variant="outline"
                  className="w-full border-[var(--border-color)] hover:border-[#E30613]"
                >
                  <img src="https://upload.wikimedia.org/wikipedia/commons/7/78/Google_Play_Store_badge_EN.svg" alt="Google Play" className="h-6" />
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AppDownload;